<template>
  <div>
    <h3>创建养号任务</h3>
    <div class="selecttext">模式选择：</div>
    <div class="tab-box">
      <a-tabs type="card" @change="callback">
        <a-tab-pane key="1" tab="新号养号任务">
          <div>
            <div class="tabtip">
              说明：<br />
              "新号养号任务"主要包括：每日创建内部群、每日群内小助手互相发言、每天发朋友圈、每天随机进行私聊。
            </div>
            <a-form-model
              layout="inline"
              style="dispaly: flex; flex-direction: column"
              ref="ruleForm1"
              :model="form1"
              :rules="formRules1"
            >
              <a-form-model-item label="任务名称" prop="task_name1" ref="name">
                <a-input
                  style="width: 200px"
                  placeholder="请输入任务名称"
                  v-model="form1.task_name1"
                  :maxLength="15"
                />
              </a-form-model-item>
              <a-form-model-item label="选择小助手" style="display: flex">
                <a-upload
                  style="display: inline-block"
                  name="file"
                  :showUploadList="false"
                  accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  :customRequest="uploadCommonMiniParams1"
                >
                  <a-button> <a-icon type="upload" /> 上传文件 </a-button>
                </a-upload>
                <a
                  href="https://ddywbdthumb.oss-cn-beijing.aliyuncs.com/新号养号任务小助手上传模版.xlsx"
                  download="券码上传模版.xlsx"
                  style="color: blue; margin-left: 10px;font-size:10px"
                  >下载模版</a
                >
                <div class="excal-tip" v-if="form1.task_excal_url1">
                  <a-icon
                    type="check-circle"
                    theme="twoTone"
                    style="color: green"
                  />
                  上传成功！
                  <div>
                    已上传<span style="color: blue">{{
                      this.form1.task_excal_num1
                    }}</span
                    >个小助手
                  </div>
                </div>
              </a-form-model-item>
            </a-form-model>
          </div>
        </a-tab-pane>
        <a-tab-pane key="0" tab="老号养号任务">
          <div>
            <div class="tabtip">
              说明：<br />
              "老号养号任务"主要包括：每日创建内部群、每日群内小助手互相发言。
            </div>
            <a-form-model
              layout="inline"
              style="dispaly: flex; flex-direction: column"
              ref="ruleForm2"
              :model="form2"
              :rules="formRules2"
            >
              <a-form-model-item label="任务名称" prop="task_name2" ref="name">
                <a-input
                  style="width: 200px"
                  :maxLength="15"
                  placeholder="请输入任务名称"
                  v-model="form2.task_name2"
                />
              </a-form-model-item>
              <a-form-model-item label="选择小助手" style="display: flex">
                <a-upload
                  style="display: inline-block"
                  name="file"
                  :showUploadList="false"
                  accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  :customRequest="uploadCommonMiniParams2"
                >
                  <a-button> <a-icon type="upload" /> 上传文件 </a-button>
                </a-upload>
                <a
                  href="https://ddywbdthumb.oss-cn-beijing.aliyuncs.com/老号养号任务小助手上传模版.xlsx"
                  download="券码上传模版.xlsx"
                  style="color: blue; margin-left: 10px;;font-size:10px"
                  >下载模版</a
                >
                <div class="excal-tip" v-if="form2.task_excal_url2">
                  <a-icon
                    type="check-circle"
                    theme="twoTone"
                    style="color: green"
                  />
                  上传成功！
                  <div>
                    已上传<span style="color: blue">{{
                      this.form2.task_excal_num2
                    }}</span
                    >个小助手
                  </div>
                </div>
              </a-form-model-item>
            </a-form-model>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div class="footer-btn">
      <a-button @click="cancelCreat">取消</a-button>
      <a-button type="primary" style="margin-left: 50px" @click="submitTask"
        >确认</a-button
      >
    </div>
  </div>
</template>

<script>
const axios = require("axios");
export default {
  name: "CreatRaisetask",
  data() {
    return {
      //上传task文件
      uploadExcalUrl:
        global.DOMAIN + "Raisebot/upload_raise_bot",
      //创建task
      createTaskUrl: global.DOMAIN + "Raisebot/add_bot",
      token: { token: sessionStorage.token },
      //两种类型form
      form1: {
        task_name1: "",
        task_excal_url1: "",
        task_excal_num1: "",
      },
      formRules1: {
        task_name1: [
          { required: true, message: "请输入任务名称", tirgger: "blur" },
        ],
      },
      form2: {
        task_name2: "",
        task_excal_url2: "",
        task_excal_num2: "",
      },
      formRules2: {
        task_name2: [
          { required: true, message: "请输入任务名称", tirgger: "blur" },
        ],
      },
      //创建提交参数
      submitParams: {
        token: sessionStorage.token,
        task_name: "",
        exl_url: "",
        bot_type: 1,
      },
    };
  },
  methods: {
    //excal上传
    uploadCommonMiniParams1(info) {
      this.submitParams.bot_type = 1;
      this.uploadExcalFn(info);
    },
    uploadCommonMiniParams2(info) {
      this.submitParams.bot_type = 0;
      this.uploadExcalFn(info);
    },
    uploadExcalFn(info) {
      let formData = new FormData();
      formData.append("file", info.file);
      formData.append("token", sessionStorage.token);
      this.axios.post(this.uploadExcalUrl, formData).then((res) => {
        if (res.data.err_code === 0) {
          if (this.submitParams.bot_type == 1) {
            this.$set(this.form1, "task_excal_url1", res.data.content.url);
            this.$set(
              this.form1,
              "task_excal_num1",
              res.data.content.data.bots
            );
          } else {
            this.$set(this.form2, "task_excal_url2", res.data.content.url);
            this.$set(
              this.form2,
              "task_excal_num2",
              res.data.content.data.bots
            );
          }
        } else {
          this.$message.error('请下载模板并按提示进行填写，确保包含‘机器人名称’，‘设备id’，‘机器人id’！');
        }
      });
    },
    //点击切换tabs
    callback(val) {
      this.submitParams.bot_type = Number(val);
    },
    // 取消
    cancelCreat() {
      this.$router.push("/RaiseAccount");
    },
    //验证excal
    formVaild() {
      //新号
      if (this.submitParams.bot_type == 1 && !this.form1.task_excal_url1) {
        this.$message.error("请上传新号小助手");
        return false;
      }
      //老号
      if (this.submitParams.bot_type == 0 && !this.form2.task_excal_url2) {
        this.$message.error("请上传老号小助手");
        return false;
      }
      return true;
    },
    //确认创建
    submitTask() {
      //新号创建task
      if (this.submitParams.bot_type == 1) {
        this.$refs.ruleForm1.validate((valid) => {
          if (valid) {
            if (!this.formVaild()) return;
            //整理传参
            this.$set(this.submitParams, "task_name", this.form1.task_name1);
            this.$set(this.submitParams, "exl_url", this.form1.task_excal_url1);
            this.creatFn();
          } else {
            return false;
          }
        });
      } else {
        this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
            if (!this.formVaild()) return;
            //整理传参
            this.$set(this.submitParams, "task_name", this.form2.task_name2);
            this.$set(this.submitParams, "exl_url", this.form2.task_excal_url2);
            this.creatFn();
          } else {
            return false;
          }
        });
      }
    },
    //调用创建接口
    creatFn() {
      this.axios.post(this.createTaskUrl, this.submitParams).then((res) => {
        if (res.data.err_code === 0) {
          this.$message.success("创建成功");
          this.$router.push("/RaiseAccount");
        } else {
          this.$message.error(res.data.discription);
        }
      });
    },
  },
};
</script>

<style scoped>
.selecttext {
  width: 100px;
  text-align: center;
}
.selecttext:after {
  content: "";
  display: inline-block;
  width: 3px;
  height: 16px;
  background: #2e9aff;
  position: relative;
  top: 3px;
  left: -82px;
}
.tab-box {
  margin-top: 10px;
}
.tabtip {
  padding: 10px;
  width: 600px;
  font-size: 10px;
  background: #cce9f5;
  border-radius: 10px;
}
.tab-box /deep/ .ant-form {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}
.excal-tip {
  font-weight: 600;
}
.footer-btn {
  margin-top: 50px;
}
</style>